<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eviSel/tc-custom/9781610583596.jpg?1699511997385" alt="This image is the cover for the book Fantasy Art Bible"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fantasy Art Bible
      </h1>
      <p class="bookDescription body article font2">
        <p>An inspirational and practical guide to fantasy and science fiction art techniques.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Quarto Publishing Group
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chart Wall Books, INC.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29ab4859